import { useEffect, useState } from "react";
import { Row, Col, Form, FormCheck } from "react-bootstrap";
import {
  useGetAllGenreQuery,
  useGetSubGenreByGenreQuery,
} from "../../slices/adminApiSlice";

const PlaylistsGenreSubgenre = ({
  programDetails,
  setProgramDetails,
  setFormEdited,
  isLocked,
}) => {
  const [genreId, setGenreId] = useState();
  const [skipSubgenre, setSkipSubgenre] = useState(true);

  const {
    data: genre,
    isLoading: genreLoading,
    isError: genreError,
  } = useGetAllGenreQuery();

  const {
    data: subgenreData,
    isLoading: subgenreDataLoading,
    isError: subgenreDataError,
  } = useGetSubGenreByGenreQuery(genreId, {
    skip: skipSubgenre,
  });

  useEffect(() => {
    if (typeof genreId === "string" && genreId.trim() !== "") {
      setSkipSubgenre(false);
    } else {
      setSkipSubgenre(true);
    }
  }, [genreId]);

  useEffect(() => {
    setGenreId(programDetails.Genre.Genre);
  }, [programDetails]);

  return (
    <>
      <Row className="align-items-center pt-2 ">
        <Col xs={3}>Genre: </Col>
        <Col>
          <Form.Select
            value={programDetails.Genre.Genre || ""}
            // xs="2"
            size="sm"
            id="Genre"
            onChange={(e) => {
              setProgramDetails({
                ...programDetails,
                Genre: {
                  ...programDetails.Genre,
                  Genre: e.target.value,
                  isDirty: true,
                },
              });
              setGenreId(e.target.value);
              setFormEdited(true);
            }}
            disabled={isLocked}
            className={programDetails.Genre.isDirty && "text-danger"}
          >
            <option value="">Select Genre</option>
            {genreLoading && "Loading Parental Ratings..."}
            {genreError && "Error loading Parental Ratings"}
            {genre &&
              genre.map((Genre) => (
                <option
                  key={Genre._id}
                  value={Genre._id}
                >
                  {Genre.genre}
                </option>
              ))}
          </Form.Select>
        </Col>
        <Col sm="1">
          <FormCheck
            type="checkbox"
            isValid
            checked={programDetails.Genre.isDirty}
            id="GenreisDirty"
            onChange={(e) => {
              setProgramDetails({
                ...programDetails,
                Genre: {
                  ...programDetails.Genre,
                  isDirty: e.target.checked,
                },
              });
              setFormEdited(true);
            }}
            disabled={isLocked}
          />
        </Col>
      </Row>
      <Row className="align-items-center pt-2 pb-4">
        <Col xs={3}>SubGenre: </Col>
        <Col>
          <Form.Select
            value={programDetails.Subgenre.Subgenre || ""}
            // xs="2"
            size="sm"
            id="Subgenre"
            onChange={(e) => {
              setProgramDetails({
                ...programDetails,
                Subgenre: {
                  ...programDetails.Subgenre,
                  Subgenre: e.target.value,
                  isDirty: true,
                },
              });
              setFormEdited(true);
            }}
            disabled={isLocked}
            className={programDetails.Subgenre.isDirty && "text-danger"}
          >
            <option value="">Select SubGenre</option>
            {subgenreDataLoading && "Loading Parental Ratings..."}
            {subgenreDataError && "Error loading Parental Ratings"}
            {subgenreData &&
              subgenreData.map((e) => (
                <option
                  key={e._id}
                  value={e._id}
                >
                  {e.SubGenre}
                </option>
              ))}
          </Form.Select>
        </Col>
        <Col sm="1">
          <FormCheck
            type="checkbox"
            isValid
            checked={programDetails.Subgenre.isDirty}
            id="SubgenreisDirty"
            onChange={(e) => {
              setProgramDetails({
                ...programDetails,
                Subgenre: {
                  ...programDetails.Subgenre,
                  isDirty: e.target.checked,
                },
              });
              setFormEdited(true);
            }}
            disabled={isLocked}
          />
        </Col>
      </Row>
    </>
  );
};
export default PlaylistsGenreSubgenre;
